import React from 'react';
import { IconProps } from '.';

const SvgCartRemove = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M9.5 18.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM16.5 18.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM6.62 6.75h4.88v1.5H6.786l.827 7.5h10.679L19.983 10h1.564l-2.133 7.25H6.27l-1.324-12H1.5v-1.5h4.79l.33 3Z'
      />
      <path
        fill={color}
        d='m22.81 5-3.53 3.53-1.06-1.06 1.72-1.72H15.5V11H14V4.25h5.94l-1.72-1.72 1.06-1.06L22.81 5Z'
      />
    </svg>
  );
};

export default SvgCartRemove;
